import { render, staticRenderFns } from "./tabs-router.vue?vue&type=template&id=0733864a&scoped=true&"
import script from "./tabs-router.vue?vue&type=script&lang=js&"
export * from "./tabs-router.vue?vue&type=script&lang=js&"
import style0 from "./tabs-router.vue?vue&type=style&index=0&id=0733864a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0733864a",
  null
  
)

export default component.exports